module.exports = __webpack_public_path__ + "static/media/screenshot-wordcloud.753aa137.png";